import { z } from 'zod';

import { ConversationIdSchema, MessageIdSchema } from './message_envelope';

/**
 * Cross-service wire contract, not a persisted document (no `_schemaVersion`): a human
 * (Zendesk agent or board operator) replied in an app-channel conversation. The live-activity
 * worker turns it into a push for the traveler's phones.
 */
export const CONVERSATION_OPERATOR_REPLIED = 'conversation.operator_replied' as const;

export const ConversationOperatorRepliedEventSchema = z
  .object({
    version: z.literal(1),
    conversationId: ConversationIdSchema,
    messageId: MessageIdSchema,
    /** customer-api publicId, the same key the phone registered under. */
    customerPublicId: z.string().min(1).max(200),
    publishedAt: z.iso.datetime(),
  })
  .strict();
export type ConversationOperatorRepliedEvent = z.infer<
  typeof ConversationOperatorRepliedEventSchema
>;
